import { render } from "./VsCollapse.vue?vue&type=template&id=6d6c46d4"
import script from "./VsCollapse.vue?vue&type=script&lang=js"
export * from "./VsCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__